import { Table } from "antd";

function TableAntd(props) {
  const {
    dataSource = [],
    columns = [],
    setPage = null,
    pageSize = 10,
  } = props;

  const dataSourceWithKeys = dataSource.map((item, index) => {
    return { ...item, key: index };
  });

  return (
    <div className="overflow-x-auto w-auto">
      <Table
        rowClassName={(record, index) =>
          index % 2 === 0 ? "bg-white" : "bg-gray-100"
        }
        columns={columns}
        dataSource={dataSourceWithKeys}
        pagination={{
          pageSize,
          onChange(current) {
            setPage(current);
          },
        }}
      />
    </div>
  );
}

export default TableAntd;
